
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoashtavinayakdarshan() {



    const cardData =
    {
        keyword: 'Pune to Ashtavinayak Darshan Cabs',
        heading: 'Platinum24 Cabs: Pune to Ashtavinayak Darshan Cabs',
        headingDescription: ' Platinum24 Cabs offers dedicated Pune to Ashtavinayak Darshan Cabs, making your spiritual journey to the eight revered Ganesh temples of Maharashtra comfortable and stress-free. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures safe and smooth travel across all temple routes. With professional chauffeurs familiar with the Ashtavinayak circuit, we guarantee timely darshan, convenient travel breaks, and a peaceful pilgrimage experience. Whether you’re planning a one-day trip or a multi-day itinerary, Platinum24 Cabs provides affordable packages, transparent pricing, and reliable service for your Ashtavinayak Darshan from Pune.',

        top: 'Top Places to Visit in Ashtavinayak with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shree Mayureshwar Temple – Morgaon",
    "description": "The Mayureshwar Temple at Morgaon is considered the starting and ending point of the Ashtavinayak Yatra. Dedicated to Lord Ganesha in the form of Mayureshwar riding a peacock, it is believed to remove obstacles from devotees’ lives. The temple has four gateways symbolizing the four directions of the universe. Built in the 14th century, it reflects Maratha and Mughal architectural influences. Pilgrims believe darshan here completes spiritual balance. Morgaon is Ashtavinayak’s gateway of devotion."
  },
  {
    "title": "Shree Siddhivinayak Temple – Siddhatek",
    "description": "Siddhatek’s Siddhivinayak Temple sits on the banks of the Bhima River, surrounded by hills and scenic beauty. This swayambhu idol is believed to grant siddhi (spiritual power) and success. Devotees climb 250+ steps to reach the shrine, making it both a pilgrimage and adventure. Lord Vishnu himself is believed to have performed penance here. The peaceful environment enhances meditation and prayer. Siddhatek is Ashtavinayak’s temple of fulfillment and blessings."
  },
  {
    "title": "Shree Ballaleshwar Temple – Pali",
    "description": "The Ballaleshwar Temple in Pali is unique as it is the only Ganesha temple named after a devotee, Ballal. Built in the 17th century, it is designed so that the morning sun’s rays fall directly on the idol. The temple’s east-facing sanctum glows with divine light at sunrise. A nearby lake, Dhundi Vinayak, is also worshipped before darshan. Devotees visit to seek blessings for true devotion and family harmony. Ballaleshwar is Ashtavinayak’s shrine of devotion and faith."
  },
  {
    "title": "Shree Varadvinayak Temple – Mahad",
    "description": "Varadvinayak Temple at Mahad is famous for granting wishes and blessings to devotees. The swayambhu idol is placed in a simple yet powerful sanctum. Unlike other temples, devotees are allowed to directly touch and worship the idol here. A continuously burning oil lamp since 1892 adds sacred charm. The temple pond nearby is considered holy. Varadvinayak is Ashtavinayak’s shrine of prosperity and fulfillment."
  },
  {
    "title": "Shree Chintamani Temple – Theur",
    "description": "The Chintamani Temple at Theur is believed to bring peace of mind and wisdom. Legend says Lord Ganesha retrieved the Chintamani jewel for Sage Kapila here. Built during the Peshwa era, it is one of the largest and most ornate Ashtavinayak temples. The idol is adorned with jewels, enhancing its grandeur. Pilgrims come here to relieve mental stress and anxiety. Theur is Ashtavinayak’s temple of wisdom and tranquility."
  },
  {
    "title": "Shree Girijatmaj Temple – Lenyadri",
    "description": "Girijatmaj Temple in Lenyadri is the only Ashtavinayak shrine located inside a cave. Dedicated to Lord Ganesha as the son of Goddess Parvati (Girija), it requires climbing 307 steps to reach. The cave is serene, with natural light illuminating the idol. It offers panoramic views of valleys and hills around. Pilgrims believe Parvati performed penance here to be blessed with Ganesha. Girijatmaj is Ashtavinayak’s temple of divine motherhood."
  },
  {
    "title": "Shree Vighneshwar Temple – Ozar",
    "description": "Vighneshwar Temple at Ozar is dedicated to Lord Ganesha as the remover of obstacles. The temple’s golden dome, deepmalas (lamp towers), and intricate stonework make it grand. The idol here is swayambhu, adorned with jewels and ornaments. Pilgrims believe darshan here ensures victory in endeavors and protection from troubles. The temple celebrates Ganesh Chaturthi with grandeur. Ozar is Ashtavinayak’s temple of success and protection."
  },
  {
    "title": "Shree Mahaganapati Temple – Ranjangaon",
    "description": "Mahaganapati Temple at Ranjangaon is considered the most powerful among the Ashtavinayak shrines. The idol is massive, with eight trunks and ten arms, though only the smaller form is usually visible to devotees. It is believed that Lord Shiva worshipped Ganesha here before defeating the demon Tripurasura. The temple’s spiritual energy and architecture make it unique. Ranjangaon is the final destination of the Yatra. Mahaganapati is Ashtavinayak’s temple of supreme power."
  }
],



      "services": [
    {
      "name": "Pune to Ashtavinayak Darshan Taxi",
      "description": "Specialized taxi services from Pune to the sacred Ashtavinayak temples, designed to provide devotees with comfortable and hassle-free travel. The service includes door-to-door pickups, flexible itineraries covering all eight temples, and experienced drivers familiar with pilgrimage routes to ensure a spiritually fulfilling journey."
    },
    {
      "name": "Ashtavinayak Tour Cab Pune",
      "description": "Comprehensive tour cab options from Pune for the Ashtavinayak Yatra, featuring a range of vehicles to accommodate solo travelers, families, and large groups. These cabs offer air-conditioned comfort, ample luggage space, and courteous drivers who can assist with the pilgrimage schedule."
    },
    {
      "name": "Pune Ashtavinayak Cab Booking",
      "description": "Seamless and quick cab booking services for Ashtavinayak tours from Pune, available online or via phone. Customers can select vehicles, customize travel plans, and receive instant confirmations to make their pilgrimage planning effortless and efficient."
    },
    {
      "name": "Ashtavinayak Yatra from Pune",
      "description": "Organized travel packages for the entire Ashtavinayak Yatra starting from Pune, including round trips, multi-day tours, and optional guided visits. The packages are designed to balance spiritual experience with comfort and convenience, suitable for pilgrims of all ages."
    },
    {
      "name": "Pune Ashtavinayak Taxi Packages",
      "description": "Flexible and affordable taxi packages tailored for the Ashtavinayak pilgrimage, including single-day and multi-day options. Packages cover all travel costs such as fuel, tolls, and driver allowances, ensuring transparent pricing and no hidden charges."
    },
    {
      "name": "Pune to Ashtavinayak Pilgrimage Cab",
      "description": "Dedicated pilgrimage cabs for Ashtavinayak tours, equipped to provide safe and smooth transportation across temple destinations. These cabs prioritize passenger comfort during long journeys and include amenities like bottled water, mobile charging, and scenic route options."
    },
    {
      "name": "Affordable Ashtavinayak Tour Cabs Pune",
      "description": "Cost-effective cab services for Ashtavinayak tours from Pune without compromising on quality or safety. Ideal for budget-conscious pilgrims looking for reliable transport with experienced drivers and well-maintained vehicles."
    },
    {
      "name": "Pune Ashtavinayak Tempo Traveller",
      "description": "Spacious Tempo Traveller rental services from Pune for group Ashtavinayak tours, perfect for large families, corporate groups, or religious organizations. These vehicles offer ample seating and luggage capacity along with comfortable travel amenities."
    },
    {
      "name": "Pune to Ashtavinayak Cab with Driver",
      "description": "Professional chauffeur-driven cabs for the Ashtavinayak pilgrimage, ensuring safe driving, knowledgeable route guidance, and courteous service throughout the journey. Drivers assist with temple timings and provide local insights to enhance the travel experience."
    },
    {
      "name": "Pune Ashtavinayak Tour Bus",
      "description": "Chartered bus services for large Ashtavinayak pilgrim groups from Pune, offering comfortable seating, air conditioning, and organized boarding and drop-off points. Suitable for schools, temples, and community groups planning collective visits."
    },
    {
      "name": "Pune to Ashtavinayak Car Rental",
      "description": "Flexible car rental options for the Ashtavinayak Yatra, available on hourly, daily, or trip-based packages. Choose from a variety of vehicles including hatchbacks, sedans, SUVs, and tempo travellers to match group size and preferences."
    },
    {
      "name": "Pune Ashtavinayak Taxi Charges",
      "description": "Transparent fare details for taxi services from Pune to Ashtavinayak temples, including breakdowns of fuel, tolls, driver allowances, and applicable taxes. Customers can request customized quotations for precise budget planning."
    },
    {
      "name": "Pune Ashtavinayak Temple Taxi",
      "description": "Taxi services focused on convenient transportation between Ashtavinayak temples, allowing devotees to visit multiple temples in a day with ease. These taxis are well-maintained, sanitized, and driven by knowledgeable drivers familiar with temple locations and timings."
    },
    {
      "name": "Pune Ashtavinayak Yatra Cabs",
      "description": "Reliable cab options specifically catering to the full Ashtavinayak Yatra circuit from Pune, ensuring timely pickups, flexible scheduling, and comfortable rides throughout the pilgrimage. Suitable for all types of travelers including senior citizens and families."
    },
    {
      "name": "Pune Ashtavinayak One Way Taxi",
      "description": "Economical one-way taxi services from Pune to any of the Ashtavinayak temples, ideal for travelers who want a point-to-point transfer without the need for round trips. This option provides flexibility and cost savings for individual legs of the pilgrimage."
    }
  ],
  "tableData": [
    ["Pune to Ashtavinayak Darshan Taxi", "Ashtavinayak Tour Cab Pune"],
    ["Pune Ashtavinayak Cab Booking", "Ashtavinayak Yatra from Pune"],
    ["Pune Ashtavinayak Taxi Packages", "Pune to Ashtavinayak Pilgrimage Cab"],
    ["Affordable Ashtavinayak Tour Cabs Pune", "Pune Ashtavinayak Tempo Traveller"],
    ["Pune to Ashtavinayak Cab with Driver", "Pune Ashtavinayak Tour Bus"],
    ["Pune to Ashtavinayak Car Rental", "Pune Ashtavinayak Taxi Charges"],
    ["Pune Ashtavinayak Temple Taxi", "Pune Ashtavinayak Yatra Cabs"],
    ["Pune Ashtavinayak One Way Taxi", "—"]
  ],


       "whychoose": [
    {
      "WhyChooseheading": "Convenient Pune to Ashtavinayak Darshan Cab Service",
      "WhyChoosedescription": "Platinum24 Cabs offers reliable and comfortable cab services for your spiritual journey to the Ashtavinayak temples."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Ashtavinayak Routes",
      "WhyChoosedescription": "Our skilled drivers know the best routes to ensure a smooth and timely pilgrimage."
    },
    {
      "WhyChooseheading": "Spacious and Comfortable Vehicles for Group Travel",
      "WhyChoosedescription": "Travel comfortably with ample space for passengers and luggage during your Ashtavinayak tour."
    },
    {
      "WhyChooseheading": "Clean and Sanitized Fleet for Your Safety",
      "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized before every trip for your health and safety."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for One-Way or Round Trips",
      "WhyChoosedescription": "Choose customizable packages that fit your pilgrimage schedule."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront pricing that covers fuel, tolls, and driver allowances for a stress-free experience."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Hassle-Free Bookings",
      "WhyChoosedescription": "Our dedicated team is available around the clock to assist with your bookings and special requests."
    },
    {
      "WhyChooseheading": "Ideal for Family, Group, and Spiritual Tours",
      "WhyChoosedescription": "Our Pune to Ashtavinayak cab services cater to all types of travelers seeking a peaceful pilgrimage."
    }
  ]






























    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab services from Pune to Ashtavinayak Darshan?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services for Pune to Ashtavinayak Darshan trips.',
    },
    {
        question: 'How can I book a Pune to Ashtavinayak Darshan cab with Platinum24 Cabs?',
        answer: 'You can easily book your Pune to Ashtavinayak Darshan cab through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Ashtavinayak Darshan trips?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, and premium cars to suit your group size and travel preferences.',
    },
    {
        question: 'Are the drivers experienced with the Pune to Ashtavinayak Darshan route?',
        answer: 'Yes, our drivers are professional, experienced, and knowledgeable about the Ashtavinayak Darshan pilgrimage route.',
    },
    {
        question: 'Can I book a round trip cab for Pune to Ashtavinayak Darshan?',
        answer: 'Absolutely! We provide round-trip cab services with flexible scheduling to suit your pilgrimage plans.',
    },
    {
        question: 'What is included in the fare for Pune to Ashtavinayak Darshan cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Ashtavinayak Darshan rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points along the Pune-Ashtavinayak Darshan route.',
    },
    {
        question: 'Are safety measures in place for Pune to Ashtavinayak Darshan cab rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols for your protection.',
    },
    {
        question: 'Is it possible to hire a cab for multiple days for Pune to Ashtavinayak Darshan travel?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your pilgrimage needs.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate taxi services for Pune to Ashtavinayak Darshan?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for Pune to Ashtavinayak Darshan routes.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Santosh Patil',
        feedback: 'The Pune to Ashtavinayak Darshan cab service by Platinum24 Cabs was comfortable and the driver was very helpful.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Kavita More',
        feedback: 'Booking a cab for Ashtavinayak Darshan was simple, and the entire trip was smooth and enjoyable.',
        rating: 5,
    },
];









































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const ashtavinayakDarshanCabsSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ashtavinayak Darshan Cabs",
  "image": "https://www.platinum24cab.com/assets/images/ashtavinayak-darshan-cab.jpg",
  "description": "Book Pune to Ashtavinayak Darshan cab with Platinum24 Cabs. Comfortable AC cars, tempo travellers, and buses available for 1-day or 2-day pilgrimage tours with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2499",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-ashtavinayak-darshan-cabs"
  }
};







    return (
        <div>

<Helmet>
  <title>Pune to Ashtavinayak Darshan Cabs | Book Pilgrimage Taxi & Tour | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Ashtavinayak Darshan cab with Platinum24 Cabs. Comfortable AC cars, tempo travellers, and buses available for 1-day or 2-day pilgrimage tours with professional drivers."
  />
  <meta
    name="keywords"
    content="Pune to Ashtavinayak Darshan Taxi, Ashtavinayak Tour Cab Pune, Pune Ashtavinayak Cab Booking, Ashtavinayak Yatra from Pune, Pune Ashtavinayak Taxi Packages, Pune to Ashtavinayak Pilgrimage Cab, Affordable Ashtavinayak Tour Cabs Pune, Pune Ashtavinayak Tempo Traveller, Pune to Ashtavinayak Cab with Driver, Pune Ashtavinayak Tour Bus, Pune to Ashtavinayak Car Rental, Pune Ashtavinayak Taxi Charges, Pune Ashtavinayak Temple Taxi, Pune Ashtavinayak Yatra Cabs, Pune Ashtavinayak One Way Taxi"
  />
  <script type="application/ld+json">
    {JSON.stringify(ashtavinayakDarshanCabsSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/33.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoashtavinayakdarshan;